import KeyValueCollection from '@deere/cps-it.warranty-model-factory/lib/key-value-pair-collection';

export const getDefaultState = () => new KeyValueCollection([
    {
        key: 'ALL',
        value: 'ALL'
    },
    {
        key: 'DTAC',
        value: 'DTAC'
    },
    {
        key: 'FACT',
        value: 'Factory'
    },
    {
        key: 'JDSN',
        value: 'Supplier'
    }
]);




// WEBPACK FOOTER //
// ./src/rga/shared/rga-domain-values/state/rga-requester-type.js